document.addEventListener("DOMContentLoaded", countdownHandler);

function countdownHandler() {
 
  const countdownRefs = {
    days: document.querySelector(
      ".countdown--timer .countdown--timer__days--number"
    ),
    hours: document.querySelector(
      ".countdown--timer .countdown--timer__hours--number"
    ),
    minutes: document.querySelector(
      ".countdown--timer .countdown--timer__minutes--number"
    ),
    seconds: document.querySelector(
      ".countdown--timer .countdown--timer__seconds--number"
    ),
  };

  let days, hours, minutes, seconds;
  // var getEndDate = window.endDate;
 
  var getEndDate = $('.pdpCountdownEndDate').attr('data-endtime');
  
  // Function to convert DD.MM.YYYY HH:mm:ss to ISO 8601 format
  function convertToISO(dateString) {
      const [datePart, timePart] = dateString.split(' '); // Split into date and time
      const [day, month, year] = datePart.split('.'); // Split DD.MM.YYYY
      // Reformat to YYYY-MM-DDTHH:mm:ss
      return `${year}-${month}-${day}T${timePart}`;
  }
  
  // Convert the date string to ISO 8601
  const normalizedEndDate = convertToISO(getEndDate);
  
  // Debugging: Log the normalized date to verify it's correct
  // console.log(normalizedEndDate, 'Normalized Date');
  
  // Convert to a timestamp
  const endDate = new Date(normalizedEndDate).getTime();
  
  // Debugging: Check if the timestamp is correct
  // console.log(endDate, 'END DATE TEST ============');
  
  // Ensure the date is not negative (indicating parsing issues)
  if (isNaN(endDate) || endDate < 0) {
      console.error('Invalid or negative date:', normalizedEndDate);
  }


  setInterval(() => {
    const startDate = new Date().getTime();
    let timeRemaining = parseInt((endDate - startDate) / 1000);

     // console.log('COUNTDOWN TIMER SHOWING UP', timeRemaining);

    if (timeRemaining >= 0) {
      days = parseInt(timeRemaining / 86400);
      timeRemaining = parseInt(timeRemaining % 86400);

      hours = parseInt(timeRemaining / 3600);
      timeRemaining = parseInt(timeRemaining % 3600);

      minutes = parseInt(timeRemaining / 60);
      timeRemaining = parseInt(timeRemaining % 60);

      seconds = parseInt(timeRemaining);

      
      countdownRefs.days.textContent = days;
      countdownRefs.hours.textContent = hours;
      countdownRefs.minutes.textContent = minutes;
      countdownRefs.seconds.textContent = seconds;
      $('.countdown--timer').css('display', 'flex');
    }
    else{
      $('.countdown--timer').hide();
    }
  }, 1000);
}
